import {skipToken} from '@reduxjs/toolkit/query';

import {useState} from 'react';

import {isNil} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {useGetFileByIdQuery} from '@dms/api/base';

import {Nullish} from 'shared/web';

import {downloadHostedFile} from '../utils/downloadHostedFile';

export const useDownloadExternalPrintout = (fileId: string | Nullish) => {
  const {currentData: fileMetadata, isFetching: isFetchingFileMetadata} = useGetFileByIdQuery(
    isNotNil(fileId) ? {fileId} : skipToken
  );
  const [pendingRequestCount, setPendingRequestCount] = useState(0);

  const downloadExternalPrintout = () => {
    if (isNil(fileMetadata)) {
      return;
    }

    setPendingRequestCount((count) => count + 1);
    return downloadHostedFile(fileMetadata.originalUri, fileMetadata.originalFilename).finally(() =>
      setPendingRequestCount((count) => count - 1)
    );
  };

  return [
    downloadExternalPrintout,
    {
      isDownloading: pendingRequestCount > 0 || isFetchingFileMetadata,
      originalFilename: fileMetadata?.originalFilename,
    },
  ] as const;
};
